interface PageProps {
    children?: React.ReactNode;
    align?: "center" | "left";
    compact?: boolean;
}

export default function Page({ children, align = "center", compact = false }: PageProps) {
    const alignClass = align === "left" ? "text-left" : "text-center";

    return (
        <div className={`flex justify-center px-3 pb-8 ${compact ? "pt-3" : "pt-6 sm:pt-10"}`}>
            <div
                className={`w-full max-w-md border border-gray-300 rounded-lg shadow-xl bg-white px-4 py-5 sm:px-6 sm:py-6 ${alignClass}`}
            >
                {children}
            </div>
        </div>
    );
}
